var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon contract",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0v4h4zM9 4V0H3.5A1.5 1.5 0 0 0 2 1.5v13A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5V5h-3.972A1 1 0 0 1 9 4zM4 2.25A.252.252 0 0 1 4.25 2h2.5a.251.251 0 0 1 .25.25v.5a.251.251 0 0 1-.25.25h-2.5A.252.252 0 0 1 4 2.75zm0 2A.251.251 0 0 1 4.25 4h2.5a.251.251 0 0 1 .25.25v.5a.251.251 0 0 1-.25.25h-2.5A.251.251 0 0 1 4 4.75zM11.5 12a.5.5 0 0 1 0 1h-1.477a1.344 1.344 0 0 1-1.207-.746.349.349 0 0 0-.629-.012l-.242.481A.528.528 0 0 1 7.5 13h-.034a.5.5 0 0 1-.438-.344L6.5 11.081l-.331 1A1.352 1.352 0 0 1 4.887 13H4.5a.5.5 0 0 1 0-1h.387a.349.349 0 0 0 .332-.238l.57-1.707a.748.748 0 0 1 1.422 0l.434 1.3a1.4 1.4 0 0 1 2.063.441.36.36 0 0 0 .316.2H11.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contract-icon.2792f199709c9187da68a638d7c91bbe.svg";
export { ForwardRef as ReactComponent };